import Link from 'next/link'

import Button from 'components/forms/Button'
import LeftRobotCard from './common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from './common/RightRobotCard'

const VirtualOfficePromoCard = () => {
  const size = useWindowSize()

  return (
    <RightRobotCard
      className='d-none d-lg-block'
      image={{
        alt: 'Robot arm holding mail',
        desktop: {
          dimensions: {
            height: 540,
            width: 668,
          },
          src: '/images/new/robot-pointing-left.png',
        },
        mobile: {
          dimensions: {
            height: 897,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isXlOrHigher ? '45%' : '0%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div
        style={{ minHeight: 520 }}
        className='d-flex flex-1 flex-column justify-content-center gap-4 px-10'
      >
        <h3 className='fw-semibold mb-0 fs-fluid-36-80 lh-105'>
          Product <span className='text-gradient-purple'>Demo</span>.
        </h3>
        <span className='fw-semibold mb-0 lh-132 fs-fluid-18-22'>
          <div className='fs-fluid-24-32'>
            <span className='fw-bold'>HaiRo™</span> brings your business mail
            to life.
          </div>
        </span>
        <span className='fs-fluid-16-22 fw-semibold'>
          With the Customer Portal, you can manage every aspect of your virtual
          office - seamlessly and efficiently.
        </span>
        <Link className='' href={'/virtual-office-london-old-street#demo'}>
          <Button className='w-100 w-lg-auto'>View a Demo</Button>
        </Link>
      </div>
    </RightRobotCard>
  )
}

export default VirtualOfficePromoCard
